let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bsKy5")).then(() => parcelRequire('l2sep'));